import { useThumbnailStore } from './thumbnailStore';

interface ObjectThumbnailProps {
  assetId: string;
  label: string;
  /** Square size in pixels (default 72). */
  size?: number;
}

/**
 * Renders the cached thumbnail for an object, or a subtle placeholder while
 * the offscreen renderer is still catching up. A baked-thumbnail URL that
 * fails to load (e.g. the library's thumbs/ not uploaded yet) requeues the
 * asset for live generation - lazy, since only a visible tile errors.
 */
export function ObjectThumbnail({ assetId, label, size = 72 }: ObjectThumbnailProps) {
  const dataUrl = useThumbnailStore((state) => state.thumbnails[assetId]);
  const requeueForRender = useThumbnailStore((state) => state.requeueForRender);
  const hasThumbnail = Boolean(dataUrl);

  return (
    <span
      className={`editor-thumbnail${hasThumbnail ? ' is-ready' : ' is-pending'}`}
      style={{ width: size, height: size }}
      aria-hidden={!hasThumbnail}
    >
      {hasThumbnail ? (
        <img
          className="editor-thumbnail-image"
          src={dataUrl}
          alt={label}
          loading="lazy"
          draggable={false}
          onError={() => {
            if (!dataUrl!.startsWith('data:')) requeueForRender(assetId);
          }}
        />
      ) : (
        <span className="editor-thumbnail-placeholder" />
      )}
    </span>
  );
}
